import { gql } from "@apollo/client";

export const FRANCHISE_REGIONS = gql`
  query franchiseRegions($franchise_id: Float) {
    franchiseRegions {
      id
      is_actived
      franchise {
        id
        name
      }
      acting_region {
        id
        name
      }
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export default FRANCHISE_REGIONS;
